export { default as PaperClipOutlineIcon } from './PaperClipOutlineIcon';
